"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayListWithItems = void 0;

var _dropDown = require("@clayui/drop-down");

var _form = require("@clayui/form");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _label = _interopRequireDefault(require("@clayui/label"));

var _sticker = _interopRequireDefault(require("@clayui/sticker"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _List = _interopRequireDefault(require("./List"));

var _excluded = ["value"],
    _excluded2 = ["className", "itemIdentifier", "items", "selectedItemsMap", "onSelectedItemsChange", "spritemap"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ListItem = function ListItem(_ref) {
  var description = _ref.description,
      dropDownTriggerProps = _ref.dropDownTriggerProps,
      dropdownActions = _ref.dropdownActions,
      href = _ref.href,
      labels = _ref.labels,
      onSelectChange = _ref.onSelectChange,
      quickActions = _ref.quickActions,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      spritemap = _ref.spritemap,
      title = _ref.title;
  return /*#__PURE__*/_react.default.createElement(_List.default.Item, {
    active: selected,
    flex: true
  }, onSelectChange && /*#__PURE__*/_react.default.createElement(_List.default.ItemField, null, /*#__PURE__*/_react.default.createElement(_form.ClayCheckbox, {
    "aria-label": "checkbox",
    checked: selected,
    onChange: function onChange() {
      onSelectChange(!selected);
    }
  })), /*#__PURE__*/_react.default.createElement(_List.default.ItemField, null, /*#__PURE__*/_react.default.createElement(_sticker.default, {
    displayType: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "folder"
  }))), /*#__PURE__*/_react.default.createElement(_List.default.ItemField, {
    expand: true
  }, /*#__PURE__*/_react.default.createElement(_List.default.ItemTitle, {
    href: href
  }, title), /*#__PURE__*/_react.default.createElement(_List.default.ItemText, null, description), labels && /*#__PURE__*/_react.default.createElement("div", {
    className: "list-group-detail"
  }, labels.map(function (_ref2, j) {
    var value = _ref2.value,
        others = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/_react.default.createElement(_label.default, _extends({}, others, {
      key: j
    }), value);
  }))), /*#__PURE__*/_react.default.createElement(_List.default.ItemField, null, quickActions && /*#__PURE__*/_react.default.createElement(_List.default.QuickActionMenu, null, quickActions.map(function (action, j) {
    return /*#__PURE__*/_react.default.createElement(_List.default.QuickActionMenu.Item, {
      key: j,
      onClick: action.onClick,
      spritemap: spritemap,
      symbol: action.symbol
    });
  })), dropdownActions && /*#__PURE__*/_react.default.createElement(_dropDown.ClayDropDownWithItems, {
    items: dropdownActions,
    spritemap: spritemap,
    trigger: /*#__PURE__*/_react.default.createElement("button", _extends({
      type: "button"
    }, dropDownTriggerProps, {
      className: "component-action"
    }), /*#__PURE__*/_react.default.createElement(_icon.default, {
      spritemap: spritemap,
      symbol: "ellipsis-v"
    }))
  })));
};

var ClayListWithItems = function ClayListWithItems(_ref3) {
  var className = _ref3.className,
      _ref3$itemIdentifier = _ref3.itemIdentifier,
      itemIdentifier = _ref3$itemIdentifier === void 0 ? 'id' : _ref3$itemIdentifier,
      _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items,
      _ref3$selectedItemsMa = _ref3.selectedItemsMap,
      selectedItemsMap = _ref3$selectedItemsMa === void 0 ? {} : _ref3$selectedItemsMa,
      onSelectedItemsChange = _ref3.onSelectedItemsChange,
      spritemap = _ref3.spritemap,
      otherProps = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, otherProps, {
    className: (0, _classnames.default)(className)
  }), /*#__PURE__*/_react.default.createElement(_List.default, null, items.map(function (item, i) {
    if (item.items) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: "headerGroup".concat(i)
      }, /*#__PURE__*/_react.default.createElement(_List.default.Header, null, item.header), item.items.map(function (subItem) {
        var key = subItem[itemIdentifier];
        return /*#__PURE__*/_react.default.createElement(ListItem, _extends({}, subItem, {
          key: key,
          onSelectChange: onSelectedItemsChange ? function () {
            onSelectedItemsChange(_objectSpread(_objectSpread({}, selectedItemsMap), {}, _defineProperty({}, key, !selectedItemsMap[key])));
          } : undefined,
          selected: selectedItemsMap[key],
          spritemap: spritemap
        }));
      }));
    }

    var key = item[itemIdentifier];
    return /*#__PURE__*/_react.default.createElement(ListItem, _extends({}, item, {
      key: key,
      onSelectChange: onSelectedItemsChange ? function () {
        onSelectedItemsChange(_objectSpread(_objectSpread({}, selectedItemsMap), {}, _defineProperty({}, key, !selectedItemsMap[key])));
      } : undefined,
      selected: selectedItemsMap[key],
      spritemap: spritemap
    }));
  })));
};

exports.ClayListWithItems = ClayListWithItems;